export default __webpack_public_path__ + "static/media/logo-colored-white.cd02c5c9.png";